import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import NavMenu from './nav-menu';
import DownIcon from 'grommet/components/icons/base/Down';
import Utils from 'medscape/utils';

export default class SideNavInlineMenu extends React.Component{
    constructor(props){
        super(props);
        this.settings = props.isMobile ? props.navigation.mobile : props.navigation.desktop;
        this.expandedSubmenu = null;
    }
    componentWillUnmount(){
        //console.log("Nav Unmount");
       //$('body').off('click.nav');
    }
    componentDidMount() {
        //console.log("Nav Mount");
        //this.bindEvents();
    }
    componentDidUpdate(){
        //this.bindEvents();
    }
    bindEvents(){
        if(this.settings.toggleSubmenu=='onClick' && this.settings.submenuType=='layer'){
            $('body').on('click.nav',(e)=>{
                if($(e.target).closest('.submenu-parent').length==0){
                    this.hideExpandedSubmenuLayer();
                }
            })
        }
    }
    getTemplate(route){

    }

    doItemClick(navItem){
        if(navItem.props.item.submenu!=null && navItem.props.item.submenu.length>0){
            if(!navItem.state.isExpanded){
                this.expandedSubmenu = navItem;
            }
            navItem.setState({
                isExpanded: !navItem.state.isExpanded
            });
        }
    }
    render() {
        console.log("Render Nav");
    	
		const navItems = this.props.navigation.links;
        let _class = cx({
        	'menu-container': true,
        	'position-right': this.settings.position=='right'
        })
        const NavMenuProps = {
        	items: navItems,
            settings: this.settings,
            route: this.props.route,
            isSubmenu: false,
            onItemClick: this.doItemClick.bind(this)
        }

        return (
            <nav id="navigation-module" className={_class}>
                <NavMenu {...NavMenuProps}></NavMenu>
            </nav>
        );
    }
}

SideNavInlineMenu.propTypes={
    "navigation": React.PropTypes.object.isRequired,
    "route": React.PropTypes.object.isRequired,
    "isMobile": React.PropTypes.bool
}
SideNavInlineMenu.defaultProps={
	"isMobile": window.medscape.isMobile ? window.medscape.isMobile : false
}





// WEBPACK FOOTER //
// ./src/app/navigation/side-nav-inline-menu.jsx